import Swal from 'sweetalert2'

// アラート
export const alert = Swal.mixin({
  keydownListenerCapture: true, // モーダル上で表示された時にEscキー押下を先にキャプチャーする
  stopKeydownPropagation: true, // デフォルト値と同じだが、keydownListenerCapture指定時にこれも指定しないとキー入力時にエラーが出る
  heightAuto: false, // bodyにheight: auto !importantが設定されないようにする
})
//トースト
export const toast = Swal.mixin({
  toast: true,
})

export default {
  install: function (Vue) {
    Vue.prototype.$alert = alert
    Vue.prototype.$toast = toast
  },
  name: 'Sweetalert2',
}
